import { SegmentUnit } from 'shared/types/segment';

/**
 * Column configuration for the segment units UniversalTable.
 * Mirrors ClusterUnitsTableConfig but without the actions column.
 */
export const SEGMENT_UNITS_COLUMNS = {
  columns: [
    {
      id: 'unitId',
      label: 'ID',
      sortKey: 'unitId',
      minWidth: 90,
      defaultWeight: 1,
    },
    {
      id: 'referencePlus',
      label: 'Referentie+',
      sortKey: 'referencePlus',
      minWidth: 100,
      defaultWeight: 1,
    },
    {
      id: 'unitType',
      label: 'Type',
      sortKey: 'unitType',
      minWidth: 120,
      defaultWeight: 1,
    },
    {
      id: 'floor',
      label: 'Verdieping',
      sortKey: 'floor',
      minWidth: 80,
      defaultWeight: 0,
    },
    {
      id: 'grossSurface',
      label: 'Bruto m²',
      sortKey: 'grossSurface',
      minWidth: 80,
      defaultWeight: 0,
    },
    {
      id: 'netSurface',
      label: 'Netto m²',
      sortKey: 'netSurface',
      minWidth: 80,
      defaultWeight: 0,
    },
    {
      id: 'building',
      label: 'Gebouw',
      sortKey: 'building',
      minWidth: 200,
      defaultWeight: 3,
    },
    {
      id: 'company',
      label: 'Vennootschap',
      sortKey: 'company',
      minWidth: 150,
      defaultWeight: 2,
    },
  ],
  localStorageKey: 'segment-units-table-v1',
};

/**
 * Sort configuration for the segment units table.
 */
export const SEGMENT_UNITS_SORT = {
  defaultSortKey: 'building',
  defaultDirection: 'asc' as const,
  fields: [
    {
      key: 'unitId',
      extractor: (row: SegmentUnit) => row.id,
    },
    {
      key: 'referencePlus',
      extractor: (row: SegmentUnit) => row.referencePlus || '',
    },
    {
      key: 'unitType',
      extractor: (row: SegmentUnit) => row.unitType || '',
    },
    {
      key: 'floor',
      extractor: (row: SegmentUnit) => row.floor ?? -1,
    },
    {
      key: 'grossSurface',
      extractor: (row: SegmentUnit) => row.grossSurface ?? -1,
    },
    {
      key: 'netSurface',
      extractor: (row: SegmentUnit) => row.netSurface ?? -1,
    },
    {
      key: 'building',
      extractor: (row: SegmentUnit) =>
        row.building?.googlePlaceLongAddress || '',
    },
    {
      key: 'company',
      extractor: (row: SegmentUnit) => row.building?.company?.name || '',
    },
  ],
};
